import React from 'react';
import Loader from 'react-loader-spinner';

const Loading = (props, loading) => {
    return (
        <div className="app-loading" style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            zIndex: 11,
            backgroundColor: 'rgba(254, 254, 254, 0.5)',
            height: '100%',
            display: 'flex',

        }}>
            <Loader
                type="Rings"
                color="#0c4da2"
                height="100"
                width="100"
            />
        </div>
    );
}

export default Loading;



// WEBPACK FOOTER //
// ./app/loading.js